// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cs-react .panel-heading{display:flex}.cs-react .panel-heading a[aria-expanded]{font-weight:bold;text-decoration:none;display:table-cell;vertical-align:middle;height:100%}.cs-react .panel-heading .button-bar{margin-left:auto}.cs-react .panel-heading .center-bar{margin:0 auto}.cs-react .panel-heading .center-bar>*,.cs-react .panel-heading .button-bar>*{color:white;margin-left:3px;margin-right:3px}.ts-panel.panel-default .cs-react .panel-heading a{color:#4682b4}\n", ""]);
// Exports
module.exports = exports;
